<template>
  <div>   
    <CRow>            
        <CCol md="12" class="pad-r-0 pad-l-0">            
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol sm="12" class="text-center">
                            <div style="min-height : 25px;"><pulse-loader :loading="filterLoading" color="green"></pulse-loader></div>
                        </CCol>
                    </CRow>
                     <CRow>
                        <CCol sm="10" class="text-center">
                            <CInput 
                                placeholder="Start typing identity name to search.."
                                v-model="searchText"
                            >
                                <template #prepend>
                                    <CButton color="primary" @click="getFilter()">
                                    <CIcon name="cil-magnifying-glass"/> Search
                                    </CButton>
                                </template>
                            </CInput>
                        </CCol>
                        <CCol sm="2">
                            <CButton type="submit" color="primary" @click="addSpecies()"><CIcon name="cil-plus"/> Add Species</CButton>
                        </CCol>
                    </CRow>                    
                    <CRow>
                        <CCol sm="12" class="text-center">
                            <div style="min-height : 25px;"><pulse-loader :loading="filterLoading" color="green"></pulse-loader></div>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CCardBody v-if="items.length > 0">
                    <b-table 
                        hover
                        selectable
                        :responsive="true"
                        select-mode="single"
                        @row-selected="onSelectRow"
                        :items="items"
                        :fields="fields"
                        style="cursor : pointer"
                        id="reportTable"
                        :per-page="15"
                        :current-page="currentPage"
                    >
                        <template v-slot:cell(dateOfAdmission)="data">
                            {{data.item.dateOfAdmission.substring(0,10)}} 
                        </template>
                        <template v-slot:cell(dateOfOutcome)="data">
                            {{data.item.dateOfOutcome != null ? data.item.dateOfOutcome.substring(0,10) : 'N/A'}} 
                        </template>
                    </b-table>
                    <b-pagination 
                        align="center"
                        v-model="currentPage"
                        :total-rows="items.length"
                        :per-page="perPage"
                        aria-controls="speciesListTable"
                    ></b-pagination>
                    
                </CCardBody>
                <CCardBody v-else>
                    <!-- <h3 class="text-danger">No species found! Please start typing indentity name to search.</h3> -->
                    <h3 class="text-danger">No species found! Please start typing identity name to search.</h3>
                </CCardBody>
            </CCard>

        </CCol>            
    </CRow> 
  </div>
</template>

<script>
import axios from 'axios';
import store from '../store';
import GridLoader from 'vue-spinner/src/GridLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
    name: 'SpeciesList',
    components: {
            GridLoader,
            PulseLoader,
    },
    mounted() {

    },
    data () {
        return {
            baseURL : store.state.baseURL,
            horizontal: { label:'col-3', input:'col-9' },
            loading : false,
            filterLoading : false,
            options : {
                
            },
            selected : {
                                
            },    
            errors : [],
            searchText : '',
            perPage: 12,
            currentPage: 1,
            fields : [
                {
                    key : 'identityName',
                    label : 'Identity'
                },
                {
                    key : 'iucnCategory',
                    label : 'IUCN Status'
                },
                {
                    key : 'class',
                    label : 'Class'
                },
                {
                    key : 'groupName',
                    label : 'Family'
                },
                {
                    key : 'categoryName',
                    label : 'Group'
                },
                
            ],
            items : [],

        }
    },
    methods: {
        reset(){
            this.loading = true;
            window.location.reload();
        },
        createNew(){
            this.errors = [];
            if(this.selected.identity == null && this.selected.scientific == null){
                this.errors.push("Please select an identity name or scientific name");
            }
            if(this.selected.placeOfRescue == null){
                this.errors.push("Place of Rescue field cannot be empty!")
            }
            if(this.selected.zoneName == null){
                this.errors.push("Place select a zone name!");
            }

            if(this.errors.length == 0){
                try{
                    this.loading = true;
                    axios({
                        url : this.baseURL + "records/create-new-record",
                        headers : {
                            authorization : store.state.token
                        },
                        method : "POST",
                        data : {
                            class           : this.selected.class != null ? this.selected.class : null,
                            family          : this.selected.family != null ? this.selected.family : null,
                            group           : this.selected.group != null ? this.selected.group : null,
                            identity        : this.selected.identity != null ? this.selected.identity : null,
                            scientific      : this.selected.scientific != null ? this.selected.scientific : null,
                            zoneName        : this.selected.zoneName != null ? this.selected.zoneName : null,
                            placeOfRescue   : this.selected.placeOfRescue != null ? this.selected.placeOfRescue : null,
                        }
                    })
                    .then(res => {
                        if(res.data.status)
                        {                     
                            this.$notify({
                                group: 'notification',
                                type : 'success',
                                title: 'New record created!',
                                text: res.data.message
                            });
                            this.$notify({
                                group: 'notification',
                                type : 'success',
                                title: 'New record created!',
                                text: "Your case ID is " + res.data.id
                            });
                            this.$router.push({name : 'Edit Case', params : { id : res.data.uid }});
                        }
                        else
                        {
                            this.$notify({
                                group: 'notification',
                                type : 'error',
                                title: 'Could not create new record!',
                                text: res.data.message
                            });
                        }
                        this.loading = false;
                    })
                    .catch(err => {
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Could not create new record!',
                            text: 'Something went wrong while creating new record! Please try again later'
                        });
                        console.log(err);
                        this.loading = false;
                    });

                }
                catch(e){
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Could not create new record!',
                        text: 'Something went wrong while creating new record! Please try again later'
                    });
                    console.log(e);
                    this.loading = false;
                }
            }
            else{
                this.showErrors();
            }

        },
        showErrors(){
            for(var i in this.errors){
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Could not create new record!',
                    text: this.errors[i]
                });
            }
            
        },
        getFilter(){
            this.filterLoading = true;
            axios({
                url : this.baseURL + "animalData/search-identity-only",
                headers : {
                    authorization : store.state.token
                },
                method : "POST",
                data : {
                    searchText : this.searchText
                }
            })
            .then(res => {
                if(res.data.status)
                {                     
                    this.items = res.data.data; 
                }
                else
                {
                    this.items = []
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
                this.filterLoading = false;
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Error in loading data. Something went wrong!'
                });
                console.log(err);
                this.filterLoading = false;
                return [];
            });

        },
        onSelectRow(row){
            this.openReport(row[0]._id);
        },
        openReport(id){
            this.$router.push('/edit-species/' + id)
        },
        addSpecies(){
            this.$router.push('/add-species');
        }    
    }
}
</script>
<style scoped>
    table, th, td {
        border: 1px solid black;
    }
</style>
